/* ============================================================
   MOSAIK — RECAP  (summary table, area & price computation)
   ============================================================ */
Object.assign(window.mosaik, {
  calculateArea:function(isPVC, obj, v){
    if(isPVC) 
        return Math.ceil( v.count / obj.collections[obj.options.currentCollection].kitNum);
    const h = obj.collections[obj.options.currentCollection].height, 
          w = obj.collections[obj.options.currentCollection].width;
    return (v.count * w * h).toFixed(2);
  },

  calcResult:function(){
    /* Drapeau lu par le diagnostic de mosaik-objects.js (audit) : il dit « le
       devis de ce thème sait compter les dalles des emplacements ». Les assets
       partent fichier par fichier, et un récap d'une génération antérieure les
       oublierait sans rien signaler. */
    this._objectsCounted = true;
    let totalPrice = 0;
    const lang = this.options.lang;
    let tileTbl = {},
        borderTbl = {},
        cornerTbl = {},
        html = '';
    // tiles
    /* LE DEVIS COMPTE CE QUI SERA LIVRÉ, donc les dalles VUES sur le plan.
       Une dalle prise par le contour d'un emplacement véhicule est comptée
       EXACTEMENT COMME SI ELLE AVAIT ÉTÉ PEINTE À LA MAIN : même ligne du
       tableau que les autres dalles de cette couleur, même surface, même prix,
       même référence au panier (mosaik-cart.js part de ce tableau). C'est bien
       cette dalle-là que le client recevra.

       Le décompte NE DÉPEND PAS des autres fichiers : la table vit dans
       mosaik-core.js, qui peut être d'une génération antérieure sur un thème en
       cours de déploiement. On la demande donc directement à la couche d'objets
       quand le core ne sait pas la fournir — un devis faux serait autrement le
       prix d'un asset pas encore monté. */
    const OV = this.tileOverrides ? this.tileOverrides()
      : ((window.MosaikObjects && MosaikObjects.enabled) ? MosaikObjects.tileOverrides(this) : null);
    const shown = (OV && OV.size)
      ? this.result.map((c, i) => (c && OV.get(i)) || c)
      : this.result;
    shown.forEach(
      c => { 
        if(!c)
          return; 
        const k = c['name_'+lang];
        if(!tileTbl[k]){
          c.count = 1;
          tileTbl[k] = c;
        } else tileTbl[k].count++; 
      });
    const isPoly = this.options.currentCollection === 'Polypropylene';
    const colCount = isPoly ? 5 : 4;
    html = '<table class="mosaik-recap-table"><thead><tr><th>' + this.getText('Image') + '</th><th>' + this.getText('Name') +
       '</th><th>' + this.getText('Number') + '</th><th>' + this.getText('Sqm') + '</th>' +
       (isPoly ? '<th>' + this.getText('Unit price') + '</th>' : '') + '</tr></thead><tbody>';
    for(let v of Object.values(tileTbl)){
        totalPrice += v.price * v.count;
        html += '<tr>'
            + '<td> <img src="'+v.img+'" height="80"></td>'
            + '<td>'+ v['name_' + lang]+ '</td>'
            + '<td>'+ v.count + '</td>'
            + '<td>' + this.calculateArea(this.options.currentCollection === 'Polypropylene', this, v)+'</td>'
            + (this.options.currentCollection === 'Polypropylene' ? '<td>'+ v.price.toFixed(2) +' € </td>' : '')
            + '</tr>';
    }
    // borders
    Object.values(this.borderAssignments).forEach(
        bo=>{const k=bo['name_'+lang];
        if(!borderTbl[k])
            borderTbl[k] = {count:1,obj:bo};else borderTbl[k].count++;});
        if(Object.keys(borderTbl).length){
            html += '<tr class="mosaik-recap-section"><td colspan="'+colCount+'">'+ this.getText('Borders') +'</td></tr>';
            for (const border in borderTbl) {
                const bo = borderTbl[border].obj;
                let total = borderTbl[border].count;
                totalPrice += bo.price * total;
                html += '<tr>'
                    +   '<td><img src="' + bo.img + '" height="80"></td>'
                    +   '<td>' + bo['name_'+lang] + '</td>'
                    +   '<td>' + total + '</td>'
                    +   '<td></td>'
                    +   (isPoly ? '<td>'+ bo.price.toFixed(2) +' € </td>' : '')
                    + '</tr>';
            }

        }
    // corners
    Object.values(this.cornerAssignments).forEach(
        co=>{
            const k = co['name_'+lang];
            if(!cornerTbl[k])
                cornerTbl[k] = {
                    count:1,
                    obj:co
                };
            else 
                cornerTbl[k].count++;
        });
    if(Object.keys(cornerTbl).length){
      html+='<tr class="mosaik-recap-section"><td colspan="'+colCount+'">'+this.getText('Corners')+'</td></tr>';
      for (const corner in cornerTbl) {
            let total = cornerTbl[corner].count;
            const co = cornerTbl[corner].obj;
            totalPrice += co.price * total;
            html += '<tr>'
                +   '<td><img src="' + co.img + '" height="80"></td>'
                +   '<td>' + co['name_'+lang] + '</td>'
                +   '<td>' + cornerTbl[corner].count + '</td>'
                +   '<td></td>'
                + (isPoly ? '<td>'+ co.price.toFixed(2) +'€ </td>' : '')
                + '</tr>';
        }
    }
    // feature layers
    if(window.MosaikLights && MosaikLights.enabled){ html += MosaikLights.recapRows(this); totalPrice += MosaikLights.price(); }
    // objets posés : les encadrements n'ont pas de prix (ils recolorent des
    // dalles déjà comptées ci-dessus), les accessoires en ont un.
    if(window.MosaikObjects && MosaikObjects.enabled){ html += MosaikObjects.recapRows(this); totalPrice += MosaikObjects.price(); }
    html += '</tbody>';
    /* Le total ne s'affiche PLUS dans le tiroir « Afficher les détails » : il est
       tenu en permanence par la barre d'action (MosaikUI.onRecalc), sur mobile
       comme au bureau, donc l'annoncer deux fois n'apporte rien. La ligne reste dans le
       DOM, `hidden`, parce que le PDF capture ce tableau et doit, lui, porter le
       prix — mosaik-pdf.js la redévoile dans le clone de capture. */
    if(isPoly)
        html += "<tfoot><tr id='totalPrice' hidden>"
              +   "<td colspan='" + (colCount - 1) + "'>" + '<br/>' + this.getText("Price including tax") + "</td>"
              +   "<td>" + totalPrice.toFixed(2) + " €</td>"
              + "</tr></tfoot>";
    html += '</table>';

    this._lastRecap = {
        tiles:   tileTbl,
        borders: borderTbl,
        corners: cornerTbl
    };
    this._total = totalPrice;
    // une seule barre d'action, sur tous les écrans (mosaik-ui.js)
    if(window.MosaikUI) MosaikUI.onRecalc(totalPrice);
    const res = document.getElementById('mosaik-result');
    if(res) res.innerHTML = html;
    /* Les deux étiquettes de dimensions qui bordaient le plan ne sont plus
       remplies ici : le plan porte des règles graduées (mosaik-render.js), qui
       disent la même chose ET où l'on en est dans le sol. Un template resté en
       cache les a encore dans son markup, vides — voir drawRulers, qui les
       escamote pour ne pas laisser deux bandes blanches autour du plan. */
  },
});
